import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import './modal.scss';

class ModalContent extends Component {
    constructor(props) {
        super(props);

        this.state = { show: false };
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.stopPropagation = this.stopPropagation.bind(this);
    }

    componentDidMount() {
        setTimeout(() => this.setState({ show: true }), 10);
    }

    handleClickOutside(e) {
        e.stopPropagation();
        if (this.props.closeOutside) {
            this.props.closeOutside();
        }
    }

    stopPropagation(e) {
        e.stopPropagation();
    }

    render() {
        const { children } = this.props;
        return ReactDOM.createPortal(
            <div onClick={this.stopPropagation} className={`modal fade stick-up${this.state.show ? ' show' : ''}`} style={{ display: 'block' }}>
                <div className="modal-backdrop show"
                     style={{zIndex: 'auto', display: this.state.show ? 'block' : 'none'}}
                     onClick={this.handleClickOutside}
                />
                <div className="modal-dialog">
                    <div className="modal-content-wrapper">
                        <div className="modal-content">
                            {children}
                        </div>
                    </div>
                </div>
            </div>,
            document.getElementById('modal-root')
        );
    }
}

ModalContent.propTypes = {
    /** A function that will be called when user clicks outside the modal */
    closeOutside: PropTypes.func,
};

export default ModalContent;



// WEBPACK FOOTER //
// ./src/components/base/secure/modals/modal-content.js